import { useEffect, useCallback } from "react";
import Lenis from "lenis";
import Header from "./components/landing/Header";
import Hero from "./components/landing/Hero";
import TrustMarquee from "./components/landing/TrustMarquee";
import Services from "./components/landing/Services";
import Process from "./components/landing/Process";
import ContactForm from "./components/landing/ContactForm";
import Footer from "./components/landing/Footer";
import FloatingCall from "./components/landing/FloatingCall";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const scrollTo = useCallback((selector) => {
    if (window.__lenis) {
      window.__lenis.scrollTo(selector, { offset: -72, duration: 1.4 });
    } else {
      document.querySelector(selector)?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="landing-page">
      <Header scrollTo={scrollTo} />
      <main>
        <Hero scrollTo={scrollTo} />
        <TrustMarquee />
        <Services />
        <Process />
        <ContactForm />
      </main>
      <Footer />
      <FloatingCall />
    </div>
  );
}

export default App;
